import { createService } from '@bonanza-social/toolkit/api';
import { PromotedContentResponseSchema } from './PromotedContentService.schemas';

export default createService({
  getPromotedContent: {
    method: 'GET',
    url: '/lobby/promotedContent',
    responseSchema: PromotedContentResponseSchema,
  },
});
